export default defineNuxtPlugin(() => {
  const {
    public: { appMode },
  } = useRuntimeConfig();

  if (!import.meta.dev && appMode === 'prod') {
    const script = document.createElement('script');
    script.src = '/scripts/sw-register.js';
    script.defer = true;
    document.head.appendChild(script);
  }
});
